exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:841px){.xvIywb{grid-column-start:2;grid-row:1/span 4;margin:5px 16px 8px 0}}.xvIywb{align-self:stretch;flex-direction:column}.Vd4i6d{border-right:4px dotted #979797;flex:1;margin-bottom:4px;margin-top:4px;width:4px;margin-left:3px}.T6Yut{border:2px solid #979797;border-radius:12px;box-sizing:border-box;height:12px;width:12px}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};